export default "/images/img-prog.png?c87d55c878b6a2624e9619cc490b5744";